/* eslint-disable @next/next/no-img-element */
'use client'

import { useAppLoading } from '@core/auth/hooks/use-app-loading/use-app-loading'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

function HomePage() {
  const router = useRouter()

  const { progress, isLoaded } = useAppLoading()

  useEffect(() => {
    if (isLoaded) {
      router.push('/redirecting')
    }
  }, [isLoaded, router])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f0f0f0',
        color: '#333',
      }}
    >
      <img
        alt="Logo"
        src="/images/hubr-logo.webp"
        style={{
          width: '100px',
          marginBottom: '20px',
          animation: 'bounce 1.5s infinite ease-in-out',
        }}
      />
      <h1>Carregando...</h1>
      <div
        style={{
          position: 'relative',
          width: '80%',
          maxWidth: '800px',
          height: '10px',
          backgroundColor: '#ddd',
          borderRadius: '5px',
          overflow: 'hidden',
          marginTop: '20px',
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: '#3182CE',
            transition: 'width 0.5s ease',
          }}
        />
      </div>
      <p>{progress}%</p>

      <style>{`
        @keyframes bounce {
          0%,
          100% {
            transform: translateY(0);  
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  )
}

export default HomePage
